import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { CheckRounded, ErrorOutlineRounded } from '@mui/icons-material';

const StatusToast = ({
    open,
    message,
    onClose,
    duration = 2000,
    instanceKey = 0,
    tone = 'success',
}) => {
    const onCloseRef = useRef(onClose);

    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    useEffect(() => {
        if (!open) {
            return undefined;
        }

        const timeout = window.setTimeout(() => {
            onCloseRef.current?.();
        }, duration);

        return () => {
            window.clearTimeout(timeout);
        };
    }, [duration, instanceKey, open]);

    if (!open || typeof document === 'undefined') {
        return null;
    }

    return createPortal(
        <div className='statusToastViewport'>
            <div
                className='statusToast'
                role={tone === 'error' ? 'alert' : 'status'}
                aria-live={tone === 'error' ? 'assertive' : 'polite'}
                aria-atomic='true'
            >
                {tone === 'error'
                    ? <ErrorOutlineRounded className='statusToastIcon' aria-hidden='true' />
                    : <CheckRounded className='statusToastIcon' aria-hidden='true' />}
                <span>{message}</span>
            </div>
        </div>,
        document.getElementById('appViewport') || document.body,
    );
};

export default StatusToast;
